/**
 * @suite/settings — the shared "open settings in a separate window" toggle.
 *
 * One preference, rendered inside every application's settings panel (hub
 * General, kor appearance, siblings' equivalents): off by default, settings
 * open as the in-app dialog; on, the settings button raises the shared
 * two-column settings window. The preference is a suite-wide localStorage
 * key, so the behavior is one across every application — and the same toggle
 * appears in the separate window itself, where flipping it takes effect for
 * the next open in any document that reads the preference at call time.
 *
 * Two shapes, so each panel keeps its own row language:
 *   - `SettingsWindowPreferenceToggle` — control only (embed in the panel's
 *     own SettingItem / SettingRow)
 *   - `SettingsWindowPreferenceRow`    — a complete suite-ui row
 */

import { useState } from "react";
import {
    isSettingsWindowPreferred,
    setSettingsWindowPreferred,
} from "./openSettings";
import { SettingRow, SettingToggle } from "./SettingsControls";

export function SettingsWindowPreferenceToggle() {
    const [preferred, setPreferred] = useState(isSettingsWindowPreferred);

    return (
        <SettingToggle
            checked={preferred}
            onChange={(next) => {
                setPreferred(next);
                setSettingsWindowPreferred(next);
            }}
            label="Open settings in a separate window"
        />
    );
}

export function SettingsWindowPreferenceRow() {
    return (
        <SettingRow
            label="Open settings in a separate window"
            hint="Off (default): settings open as a dialog inside the application. On: the settings button opens the shared two-column settings window."
            control={<SettingsWindowPreferenceToggle />}
        />
    );
}
